// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";

// ⚠️ Usa tu propia config (la tuya de screenshots es válida)
const firebaseConfig = {
  apiKey: "AIzaSyDscitn5jCyXF2_Y_12XtnCqM9AIDlm418",
  authDomain: "gestor-utensilios.firebaseapp.com",
  projectId: "gestor-utensilios",
  // Firestore no usa storageBucket, pero si lo pones debe ser *.appspot.com
  storageBucket: "gestor-utensilios.appspot.com",
  messagingSenderId: "737958778225",
  appId: "1:737958778225:web:3b5ea855892058764c12d0",
  measurementId: "G-P3CHPEW4BH",
};

// Evitar doble init (hot reload)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Firestore
export const db = getFirestore(app);

// Auth + promesa lista
const auth = getAuth(app);

/**
 * Se resuelve cuando HAY usuario (incluye anónimo).
 * Si todavía no hay sesión, la abrimos con signInAnonymously y esperamos.
 */
export const authReady = new Promise((resolve) => {
  const unsub = onAuthStateChanged(auth, (user) => {
    if (user) {
      unsub();
      resolve(user);
    }
  });
});

// Iniciar sesión anónima si aún no lo está
signInAnonymously(auth).catch((e) => {
  console.error("[auth] anon error:", e);
});
